import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function airports(state=initialState.airports, action) {
    switch (action.type) {
        case appConstants.AIRPORTS_SUCCESS:
            return action.airports;
        default:
            return state
      }
}



// WEBPACK FOOTER //
// ./src/_reducers/airport.reducer.js